import useSWR from "swr";

import { simpleFetcher } from "../fetcher";

interface UserDocumentRoles {
  ownerIn: { documentId: number; title?: string }[];
  publisherIn: { documentId: number; title: string }[];
}

export function useUserDocumentRoles(id: string | number | undefined) {
  return useSWR<UserDocumentRoles, Error>(
    id ? `/api/v2/users/${id}/document-roles` : null,
    simpleFetcher,
  );
}
